// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressViewItem.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import { ImportStatus as IMPORT_STATUS } from 'logic/data/Izenda.ImportConstants';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';

@observer
export default class ImportProgressViewItem extends Component {
  setRef = (dom: any): void => {
    this.dom = dom;
  };

  componentDidUpdate(): void {
    const { item: { status } } = this.props;

    if (status === IMPORT_STATUS.SUCCESS.value || status === IMPORT_STATUS.FAILED.value) {
      this.props.onUpdateStatus(this.dom);
    }
  }

  /**
   * Get file status description
   * @param {number} status 
   */
  getStatusDescription(status: number): string {
    switch (status) {
      case IMPORT_STATUS.SUCCESS.value:
        return IMPORT_STATUS.SUCCESS.label;
      case IMPORT_STATUS.FAILED.value:
        return IMPORT_STATUS.FAILED.label;
      default:
        return IMPORT_STATUS.NOT_PROCESSED.label;
    }
  }

  render() {
    const { item: { status, objectName } } = this.props;
    const iconClassName = classnames({
      'icon-ok-circled success': status === IMPORT_STATUS.SUCCESS.value,
      'icon-cancel-circled failed': status === IMPORT_STATUS.FAILED.value
    });

    const statusDescription = this.getStatusDescription(status);

    return (
      <div ref={this.setRef}>
        <GridLayout.Row className="izenda-ImportProgressItem u_noMarginAll">
          <GridLayout.Col cols="4">
            <OverflowText tooltip={objectName} text={objectName} />
          </GridLayout.Col>
          <GridLayout.Col cols="1">
            <span className={iconClassName} />
          </GridLayout.Col>
          <GridLayout.Col cols="7">
            <OverflowText tooltip={statusDescription} text={statusDescription} />
          </GridLayout.Col>
        </GridLayout.Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportProgressViewItem.js